import { Box, Stack } from '@mui/material'
import HealthIcon from 'assets/HealthIcon'
import { useWidgetStatistics } from 'components/farm-dashboard/hooks/useWidgetStatistics'
import { useAppSelector } from 'store/hooks'
import { COLORS } from 'styles/colors'
import { TypographyPrimary } from 'ui/typography/TypographyPrimary'
import { TypographyPrimary16Bold } from 'ui/typography/TypographyPrimary16Bold'
import { BaseWidget } from '../baseWidget'
import { useGetLamenessChartInfo } from '../lameness/hooks/useGetLamenessChartInfo'

export const LameHeads = () => {
	const { permissions } = useAppSelector(state => state.authReducer)
	const { statistics, loading, error } = useWidgetStatistics()
	const { limpnessTotalCattles } = useGetLamenessChartInfo(statistics)

	if (!permissions?.license_limpness || error) return null

	const count = statistics?.dispose_recommended?.count ?? 0
	const isMore = statistics?.dispose_recommended?.more
	return (
		<BaseWidget
			icon={
				<Box
					sx={{
						width: '24px',
						height: '24px',
						backgroundColor: COLORS.mainSecondaryOpacity,
						borderRadius: '50%',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
					}}
				>
					<HealthIcon color={COLORS.main} />
				</Box>
			}
			path={'/cattles/trim'}
			isLoading={loading}
		>
			<Stack direction='column' gap='8px'>
				<Stack direction='row' alignItems='center' gap='6px'>
					<TypographyPrimary16Bold
						sx={{ color: count === 0 ? COLORS.icon : COLORS.error }}
					>
						{limpnessTotalCattles}
					</TypographyPrimary16Bold>
					{/* {count !== 0 && (
						<ArrowCupidon
							iconColor={isMore ? COLORS.error : COLORS.success}
							direction={isMore ? 'up' : 'down'}
						/>
					)} */}
				</Stack>

				<TypographyPrimary>Хромые головы</TypographyPrimary>
			</Stack>
		</BaseWidget>
	)
}
